<template>
  <v-row v-if="lodash.isEmpty(glassesPrescriptions)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem receitas de óculos
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <v-row
        dense
        v-for="(glassesPrescription, index) in glassesPrescriptions"
        :key="glassesPrescription.id"
      >
        <v-col>
          <GlassPresciptionListItem
            :glassesPrescription="glassesPrescription"
            :index="index"
            :refreshList="refreshList"
            :allowEdit="allowEdit"
            :allowDelete="allowDelete"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import GlassPresciptionListItem from "@/components/glasses_prescription/list/item.vue";

  export default {
    name: "GlassPresciptionList",
    props: {
      attendance: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      GlassPresciptionListItem,
    },
    mounted() {
      this. refreshList();
    },
    apollo: {
      glassesPrescriptions: {
        query: require("@/graphql/glasses_prescription/glasses_prescriptions.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.glassesPrescriptions, ["createdAt"], ["asc"]);
        },
        pollInterval: 200000,
      },
    },
    methods: {
      async refreshList() {
        await this.$apollo.queries.glassesPrescriptions.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
